import React from 'react'
import { HashRouter as Router, Routes, Route } from 'react-router-dom'
import Home from 'pages/Home'
import About from 'pages/About'
import Services from 'pages/Services'
import Lawyers from 'pages/Lawyers/Lawyers'
import Contact from 'pages/Contact/Contact'
import AboutLawyer from 'pages/AboutLawyer'
import ServiceDetails from 'pages/ServiceDetails'

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/quem-somos' element={<About />} />
        <Route path='/servicos' element={<Services />} />
        <Route path='/advogados' element={<Lawyers />} />
        <Route path='/contatos' element={<Contact />} />
        
        <Route path='/lawyer/:slug' element={<AboutLawyer />} />
        <Route path='/servico/:serviceName' element={<ServiceDetails />} />
      </Routes>
    </Router>
  )
}

export default App